import { defineComponent as n } from "vue";
const a = n({
  name: "DataTableRenderFilter",
  props: {
    render: {
      type: Function,
      required: !0
    },
    active: {
      type: Boolean,
      default: !1
    },
    show: {
      type: Boolean,
      default: !1
    }
  },
  render() {
    const { render: e, active: t, show: r } = this;
    return e({
      active: t,
      show: r
    });
  }
});
export {
  a as default
};
